import React, { useContext, useEffect, useState } from 'react';
import { AuthContext, Role } from '../context/AuthProvider';
import { axiosWrapper } from '../hooks/axios';
import { useGetWithRefetch } from '../hooks/useFetchEndPoint';
import DemoAskModal from './DemoAskModal';
import PollModal from './PollModal';
import Poll from './PollModal/Poll';

const ModalContainer: React.FC = () => {
  const user = useContext(AuthContext);
  const [isPollOpen, setIsPollOpen] = useState(false);
  const [hasAskedDemoInfo, setHasAskedDemoInfo] = useState<boolean>(false);
  const [demoAskModalOpened, setDemoAskModalOpened] = useState<boolean>(false);

  const [pollResponse] = useGetWithRefetch<null | Poll[]>(
    '/api/v1/records/poll/',
  );

  const poll =
    Array.isArray(pollResponse) && pollResponse.length ? pollResponse[0] : null;

  useEffect(() => {
    if (!user || !user.is_authenticated) {
      return;
    }
    if (user.roles?.includes(Role.staff)) {
      return;
    }
    if (poll) {
      setIsPollOpen(true);
    }
  }, [user, poll]);

  useEffect(() => {
    if (user) {
      if (
        user.demos_to_ask &&
        user.demos_to_ask.length > 0 &&
        !hasAskedDemoInfo
      ) {
        const URL = '/api/v1/records/demo/asked/';
        axiosWrapper<any>(URL, 'patch', {})
          .then((res) => {
            if (res.data.ok) {
              setHasAskedDemoInfo(true);
              setDemoAskModalOpened(true);
            } else {
              alert(res.data.error);
            }
          })
          .catch((err) => console.error(err));
      }
    }
  }, [hasAskedDemoInfo, user]);

  if (poll && isPollOpen) {
    return <PollModal poll={poll} setIsOpen={setIsPollOpen} />;
  }

  if (!demoAskModalOpened) {
    return null;
  }

  return <DemoAskModal setIsOpen={setDemoAskModalOpened} />;
};

export default ModalContainer;
